import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Grid,
  MenuItem,
  Typography,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputSelectSearch from "../../../components/InputSelectSearch";
import TenantService from "../../../Services/TenantService/TenantService";
import roleStore from "../../../Store/RoleStore";
import tenantStore from "../../../Store/TenantStore";
import usersStore from "../../../Store/UsersStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

function Form(props) {
  const { classes, width, data, cancel } = props;
  const user = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(true);
  const [roleState, roleActions] = roleStore();
  const [tenantState, tenantActions] = tenantStore();
  const [, usersActions] = usersStore();
  const [optionsTenant, setOptionsTenant] = React.useState([]);
  const [listTenant, setListTenant] = React.useState([]);

  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      birthdate: new Date(),
      gender: "",
      phone: "",
      address: "",
      roles: "",
      tenant: "",
      email: "",
      password: "",
      repeatPassword: "",
      type: "tenant",
      operational: "",
    },
  });
  const [componentWillMount] = React.useState(false);

  const asyncGetOptionsTenant = (query) => {
    return new Promise((resolve, reject) => {
      TenantService.getData({
        property_id:
          user?.type === "staff" &&
          (user?.operational?.level === 1 || user?.operational?.level === 2)
            ? user?.operational?.id
            : "",
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) =>
            user?.operational?.level > 1
              ? { value: row.id, name: `${row.name} - ${row.property.name}` }
              : { value: row.id, name: row.name }
          );
          setListTenant(response.data);
          setOptionsTenant(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const loadDataRelation = (data) => {
    setLoading(true);
    var query = {
      num: "10",
      cursor: "",
      position: "",
      search: "",
      type: "tenant",
    };
    const tenantName = data ? data?.tenant?.name : "";
    Promise.all([
      roleActions.get(query),
      asyncGetOptionsTenant(tenantName),
    ]).then(() => {
      setLoading(false);
    });
  };

  React.useEffect(() => {
    loadDataRelation(data);
    if (data) {
      setState({
        formData: {
          id: data.id,
          name: data.name,
          birthdate: data.birthdate,
          gender: data.gender,
          phone: data.phone,
          address: data.address,
          roles: data.role.id,
          tenant: data.tenant.id,
          email: data.email,
          type: "tenant",
          operational: data.operational?.id,
        },
      });
    }
  }, [componentWillMount, roleActions, tenantActions, data]);

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    if (value !== state.formData.password) {
      return false;
    }
    return true;
  });

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleDateChange = (date) => {
    const { formData } = state;
    formData["birthdate"] = date;
    setState({ formData });
  };

  const handleSubmit = (event) => {
    confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
      if (props.data === null) {
        const { formData } = state;
        const objectUser = {
          roles: roleState.data,
          tenant: listTenant,
        };
        await usersActions.store(formData, objectUser);
        handleCloseDialog();
        cancel();
      } else {
        const { formData } = state;
        const objectUser = {
          roles: roleState.data,
          tenant: listTenant,
        };
        await usersActions.put(formData, objectUser);
        handleCloseDialog();
        cancel();
      }
    });
  };

  return (
    <CustomizedDialogs
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent dividers>
        {loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {!loading && (
          <ValidatorForm
            id="myform"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Grid container justify="center">
              <Grid
                container
                justify="center"
                item
                xs={width === "lg" ? 8 : 12}
              >
                <Typography
                  variant="subtitle1"
                  className={classes.header}
                  gutterBottom
                >
                  Please input your identity as required below:
                </Typography>
                <Grid container item xs={12}>
                  <Typography
                    variant="subtitle1"
                    className={classes.section}
                    gutterBottom
                  >
                    Personal Information
                  </Typography>
                </Grid>
                <Grid container item xs={11} spacing={1}>
                  <Grid item xs={12}>
                    <TextValidator
                      id="name"
                      label="Name"
                      name="name"
                      validators={["required"]}
                      className={classes.textField}
                      errorMessages={["Name is required"]}
                      margin="normal"
                      value={state.formData.name}
                      onChange={(e) => handleChange(e)}
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="birthdate"
                        name="birthdate"
                        format="dd/MM/yyyy"
                        input
                        label="Birthdate"
                        views={["year", "month", "date"]}
                        className={classes.textField}
                        value={state.formData.birthdate}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <SelectValidator
                      id="gender"
                      name="gender"
                      label="Gender"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.gender}
                      onChange={handleChange}
                    >
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      id="phone"
                      label="Phone"
                      name="phone"
                      margin="normal"
                      type="number"
                      value={state.formData.phone}
                      className={classes.textField}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      id="address"
                      label="Address"
                      name="address"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.address}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Typography
                    variant="subtitle1"
                    className={classes.section}
                    gutterBottom
                  >
                    Account Credential
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={11}
                  spacing={1}
                  style={{ paddingBottom: 30 }}
                >
                  <InputSelectSearch
                    value={state.formData.roles}
                    options={roleState.data
                      .filter((row) => row.id === 5 || row.id === 9)
                      .map((row) => ({
                        value: row.id,
                        name: row.name,
                      }))}
                    onChange={(value) =>
                      handleChange({
                        target: { name: "roles", value: value },
                      })
                    }
                    search
                    closeOnSelect={true}
                    validators={["required"]}
                    errorMessages={["Role is required"]}
                    placeholder="Search for role"
                  />

                  {user?.type !== "tenant" && (
                    <InputSelectSearch
                      value={state.formData.tenant}
                      options={optionsTenant}
                      getOptions={(query) => asyncGetOptionsTenant(query)}
                      onChange={(value) =>
                        handleChange({
                          target: { name: "tenant", value: value },
                        })
                      }
                      search
                      closeOnSelect={true}
                      validators={["required"]}
                      errorMessages={["Tenant is required"]}
                      placeholder="Search for tenant"
                    />
                  )}
                  <TextValidator
                    id="email"
                    label="Email"
                    name="email"
                    className={classes.textField}
                    inputProps={{ maxLength: 51 }}
                    validators={["required", "isEmail", "maxStringLength:50"]}
                    errorMessages={[
                      "Email is required",
                      "Email is not valid",
                      "maximum character is 50",
                    ]}
                    margin="normal"
                    autoComplete="email"
                    readOnly
                    value={state.formData.email}
                    onChange={handleChange}
                  />

                  {!data && (
                    <TextValidator
                      id="password"
                      label="Password"
                      name="password"
                      readOnly
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.password}
                      autoComplete="new-password"
                      inputProps={{ maxLength: 51 }}
                      validators={["required", "maxStringLength:50"]}
                      errorMessages={[
                        "Password is required",
                        "maximum character is 50",
                      ]}
                      type="password"
                      onChange={handleChange}
                    />
                  )}
                  {!data && (
                    <TextValidator
                      label="Repeat password"
                      onChange={handleChange}
                      className={classes.textField}
                      name="repeatPassword"
                      type="password"
                      margin="normal"
                      validators={["isPasswordMatch", "required"]}
                      errorMessages={[
                        "password mismatch",
                        "this field is required",
                      ]}
                      value={state.formData.repeatPassword}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </ValidatorForm>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions>
          <Button
            onClick={() => {
              handleCloseDialog();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            form="myform"
            variant="contained"
            style={{ marginRight: 30 }}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      )}
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};

export function submitFormTenant(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
